export default {
  brand: {
    name: '헬퍼 카지노'
  },
  nav: {
    home: '홈',
    live: '라이브',
    slots: '슬롯',
    sports: '스포츠',
    minigames: '미니게임',
    mini: '미니',
    fishing: '피싱',
    mypage: '나의 페이지',
    deposit: '입금',
    withdraw: '출금',
    event: '이벤트',
    attendance: '출석부',
    newBadge: 'NEW',
    newBadgeAria: '새로운 출석부 메뉴',
    notice: '공지사항',
    support: '고객센터',
    slip: '쪽지',
    betting: '베팅내역',
    login: '로그인',
    logout: '로그아웃',
    signup: '회원가입',
    menuOpen: '메뉴 열기',
    menuClose: '메뉴 닫기',
    telegramInquiry: '텔레그램 문의',
    telegramLiveSupport: '실시간 상담',
    mobilePrimary: '주요 메뉴',
    headerPoint: '포인트',
    headerPointConvert: '전환',
    onlineUsers: '접속중',
    onlineUsersAria: '현재 접속 중인 회원 {count}명'
  },
  sidebar: {
    ageRestrictionTitle: '미성년자 이용금지',
    ageRestrictionDesc: '만 19세 미만은 본 사이트를 이용할 수 없습니다.',
    tetherGuideTitle: '테더(USDT) 구매 · 지갑 주소 만드는 방법',
    tetherGuideDesc: '처음이어도 쉽게 따라하는 초보 가이드'
  },
  footer: {
    ariaLabel: '사이트 푸터'
  },
  maintenance: {
    title: '점검 안내',
    defaultMessage: '현재 시스템 점검 중입니다. 잠시 후 다시 이용해 주세요.'
  },
  common: {
    close: '닫기',
    confirm: '확인',
    backToList: '목록으로',
    loading: '불러오는 중...',
    refresh: '새로고침',
    balanceRefresh: '잔액 새로고침',
    prev: '이전',
    next: '다음',
    copySuccess: '복사되었습니다.',
    copyFail: '복사에 실패했습니다.',
    telegramMissing: '텔레그램 정보가 없습니다.',
    siteLoadError: '사이트 정보를 불러오지 못했습니다.',
    alertTitle: '알림',
    empty: '데이터가 없습니다.',
    noTitle: '(제목 없음)'
  },
  auth: {
    loginTitle: '로그인',
    signupTitle: '회원가입',
    signupDesc: '아래 정보를 입력하고 가입을 완료해 주세요.',
    loginId: '아이디',
    loginIdPlaceholder: '아이디',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호',
    passwordShow: '비밀번호 보기',
    passwordHide: '비밀번호 숨기기',
    loginSubmit: '로그인',
    loginSubmitting: '로그인 중...',
    loginEmptyError: '아이디와 비밀번호를 입력해 주세요.',
    loginFail: '로그인에 실패했습니다.',
    loginSuccess: '로그인되었습니다.',
    logoutSuccess: '로그아웃되었습니다.',
    accountUnavailable: '이용할 수 없는 계정입니다.',
    wrongCredentials: '아이디 또는 비밀번호가 올바르지 않습니다.',
    accountNotApproved: '승인되지 않은 계정입니다.',
    sessionExpired: '로그인이 만료되었습니다.',
    sessionInvalid: '로그인 정보가 유효하지 않습니다.',
    sessionNotFound: '로그인 정보가 없습니다. 다시 로그인해 주세요.',
    sessionDoubleLogin: '다른 기기에서 로그인되어 로그아웃되었습니다.',
    sessionNetwork: '서버에 연결할 수 없습니다. 다시 로그인해 주세요.',
    signupPrompt: '간단한 회원가입으로 이용하실 수 있습니다.',
    signupLink: '회원가입 바로가기',
    nickname: '닉네임',
    nicknamePlaceholder: '2~12자',
    loginIdRulePlaceholder: '4~12자 영문·숫자',
    passwordRulePlaceholder: '4~20자',
    passwordConfirm: '비밀번호 확인',
    passwordConfirmPlaceholder: '비밀번호 재입력',
    phone: '휴대폰 번호',
    sendCode: '인증번호 발송',
    resendCode: '재발송',
    confirmCode: '인증 확인',
    codePlaceholder: '인증번호 6자리',
    referralCode: '추천인 코드',
    referralCodePlaceholder: '추천인 코드 입력',
    referralHint: '추천인 아이디를 모르시면',
    referralHintSuffix: '해 주세요.',
    signupSubmit: '회원가입',
    signupSubmitting: '가입 처리 중...',
    hasAccount: '이미 계정이 있으신가요?',
    goLogin: '로그인하기',
    phoneVerified: '휴대폰 인증이 완료되었습니다.',
    phoneNeedVerify: '휴대폰 인증을 완료해 주세요.',
    phoneInvalid: '휴대폰 번호를 확인해 주세요.',
    phoneSendFail: '인증번호 발송에 실패했습니다.',
    phoneVerifyFail: '인증번호가 올바르지 않습니다.',
    phoneNeedCode: '인증번호를 먼저 발송해 주세요.',
    errorLoginIdRequired: '아이디를 입력해 주세요.',
    errorLoginIdFormat: '아이디는 4~12자 영문·숫자만 사용할 수 있습니다.',
    errorNicknameRequired: '닉네임을 입력해 주세요.',
    errorNicknameLength: '닉네임은 2~12자로 입력해 주세요.',
    errorPasswordRequired: '비밀번호를 입력해 주세요.',
    errorPasswordLength: '비밀번호는 4~20자로 입력해 주세요.',
    errorPasswordConfirmRequired: '비밀번호 확인을 입력해 주세요.',
    errorPasswordMismatch: '비밀번호 확인이 일치하지 않습니다.',
    errorReferralRequired: '추천인 코드를 입력해 주세요.',
    errorReferralInvalid: '추천인 코드를 확인해 주세요.',
    errorDuplicateLoginId: '이미 사용 중인 아이디입니다.',
    errorDuplicateNickname: '이미 사용 중인 닉네임입니다.',
    errorDuplicateIp: '이미 가입된 IP입니다.',
    signupFail: '회원가입에 실패했습니다.',
    signupSuccess: '가입되엇습니다.',
    signupSuccessLogin: '가입되엇습니다. 로그인해 주세요.'
  },
  games: {
    hotTitle: '인기 게임',
    providersTitle: '제공 게임사',
    hotProvidersTitle: '인기 게임사',
    hotProvidersSubtitle: '게임사를 선택하면 슬롯 목록 또는 라이브 로비로 이동합니다.',
    liveTitle: '라이브',
    liveSubtitle: '게임사를 선택하면 로그인 후 로비로 입장합니다.',
    slotsTitle: '슬롯',
    slotsSubtitle: '게임사를 선택하면 로그인 없이 게임 목록을 확인할 수 있습니다.',
    sportsTitle: '스포츠',
    sportsSubtitle: '스포츠 베팅',
    minigameTitle: '미니게임',
    fishingTitle: '피싱',
    list: '게임 목록',
    search: '게임명 검색',
    searchPlaceholder: '검색어 입력',
    loading: '게임 목록을 불러오는 중...',
    loadingProviders: '게임사 목록을 불러오는 중...',
    loadingSports: '스포츠 게임을 불러오는 중...',
    empty: '표시할 게임이 없습니다.',
    emptyProviders: '표시할 게임사가 없습니다.',
    emptySearch: '검색 결과가 없습니다.',
    expand: '더보기',
    collapse: '접기',
    play: '플레이',
    demo: '무료 체험',
    previewTagline: '지금 플레이하거나 무료 체험을 이용해 보세요.',
    recentTitle: '최근 플레이',
    recentSubtitle: '최근 플레이한 게임을 빠르게 다시 실행할 수 있습니다.',
    recentBadge: 'RECENT',
    recentEmpty: '최근 플레이한 게임이 없습니다.',
    frameTitle: '게임 플레이',
    frameEyebrow: 'Live Game',
    frameLoading: '게임을 불러오는 중...',
    frameFullscreen: '전체화면',
    frameExitFullscreen: '전체화면 종료',
    gameCountFiltered: '{shown}개 / 전체 {total}개',
    gameCountTotal: '총 {total}개 게임',
    sportsPreparing: '스포츠 게임을 준비 중입니다.',
    loadError: '게임 목록을 불러오지 못했습니다.',
    launchError: '게임 실행에 실패했습니다.',
    demoError: '무료 체험 실행에 실패했습니다.',
    sportsLaunchError: '스포츠 게임 실행에 실패했습니다.',
    providerNotFound: '게임사 정보를 확인할 수 없습니다.',
    providerNotFoundSports: '{provider} 스포츠 게임사를 찾을 수 없습니다.',
    providerNotFoundMinigame: '{provider} 게임사를 찾을 수 없습니다.',
    categorySlot: '슬롯',
    categoryLive: '라이브',
    categoryFishing: '피싱',
    categoryMini: '미니',
    categorySports: '스포츠',
    categoryAll: '전체',
    categoryOther: '기타'
  },
  jackpot: {
    title: '실시간 잭팟',
    slogan: '누적될수록 커지는 행운!',
    currentAmount: '현재 잭팟 금액',
    mega: 'MEGA',
    live: '실시간 누적 적립중'
  },
  popup: {
    aria: '팝업 공지',
    hide24h: '24시간 안보기',
    close: '닫기',
    closeAll: '전체 팝업 닫기'
  },
  slip: {
    title: '쪽지',
    desc: '받은 쪽지를 확인할 수 있습니다.',
    loading: '쪽지를 불러오는 중...',
    emptyAll: '받은 쪽지가 없습니다.',
    emptyUnread: '읽지 않은 쪽지가 없습니다.',
    emptyRead: '읽은 쪽지가 없습니다.',
    loadError: '쪽지 목록을 불러오지 못했습니다.',
    reload: '새로고침',
    reloadAria: '쪽지 목록 새로고침',
    filterAria: '쪽지 필터',
    prevPage: '이전',
    nextPage: '다음',
    colNo: '번호',
    colStatus: '상태',
    colTitle: '제목',
    colDate: '날짜',
    noTitle: '(제목 없음)',
    unreadCount: '읽지 않음 {count}건',
    unreadAria: '읽지 않은 쪽지 {count}건',
    headerNotice: '읽지 않은 쪽지가 존재합니다.',
    headerNoticeAria: '읽지 않은 쪽지 보기',
    filterAll: '전체',
    filterUnread: '읽지 않음',
    filterRead: '읽음',
    statusUnread: '읽지 않음',
    statusRead: '읽음',
    detailLoadError: '쪽지 내용을 불러오지 못했습니다.',
    detailDefaultTitle: '쪽지',
    unreadCheckMessage: '읽지 않은 쪽지를 확인해 주세요.',
    unreadCheckConfirm: '쪽지 확인'
  },
  support: {
    title: '고객센터',
    desc: '새로운 문의를 등록하고 문의 내역을 확인할 수 있습니다.',
    composeTitle: '문의하기',
    fieldTitle: '제목',
    fieldTitlePlaceholder: '문의 제목을 입력해 주세요',
    fieldContent: '내용',
    fieldContentPlaceholder: '문의 내용을 입력해 주세요',
    submit: '문의 등록',
    submitting: '등록 중...',
    historyTitle: '문의 내역',
    historyReloadAria: '문의 내역 새로고침',
    loading: '문의 내역을 불러오는 중...',
    loadError: '문의 내역을 불러오지 못했습니다.',
    empty: '등록된 문의가 없습니다.',
    colNo: '번호',
    colStatus: '상태',
    colTitle: '제목',
    colDate: '날짜',
    statusAnswered: '답변완료',
    statusPending: '대기중',
    errorTitleRequired: '제목을 입력해 주세요.',
    errorContentRequired: '내용을 입력해 주세요.',
    submitFail: '문의 등록에 실패했습니다.',
    submitSuccess: '문의가 등록되었습니다.',
    detailDefaultTitle: '문의 상세',
    detailQuestionTitle: '문의 내용',
    detailAnswerTitle: '답변',
    detailAnswerPending: '답변 대기 중입니다.',
    detailLoadError: '문의 내용을 불러오지 못했습니다.'
  },
  notice: {
    title: '공지사항',
    eventTitle: '이벤트',
    tabNotice: '공지사항',
    tabPopup: '팝업공지',
    categoryNotice: '공지사항',
    categoryPopup: '팝업공지',
    categoryEvent: '이벤트',
    priority: '중요',
    colNo: '번호',
    colCategory: '카테고리',
    colDate: '날짜',
    colTitle: '제목',
    loadingNotice: '공지사항을 불러오는 중...',
    loadingEvent: '이벤트를 불러오는 중...',
    emptyNotice: '등록된 공지사항이 없습니다.',
    emptyEvent: '등록된 이벤트가 없습니다.',
    errorNotice: '공지사항을 불러오지 못했습니다.',
    errorEvent: '이벤트를 불러오지 못했습니다.',
    detailDefaultTitle: '공지사항',
    detailLoadError: '공지 내용을 불러오지 못했습니다.'
  },
  betting: {
    title: '베팅내역',
    desc: '최근 게임 베팅 기록을 확인합니다.',
    startDate: '시작일',
    endDate: '종료일',
    gameName: '게임명',
    gameNamePlaceholder: '게임명 검색',
    search: '조회',
    totalBet: '총 베팅',
    totalWin: '총 당첨',
    profit: '손익',
    loading: '베팅내역을 불러오는 중...',
    loadError: '베팅내역을 불러오지 못했습니다.',
    empty: '조회된 베팅내역이 없습니다.',
    colDateTime: '일시',
    colProvider: '게임사',
    colGameName: '게임명',
    colCategory: '구분',
    colBetAmount: '베팅금',
    colWinAmount: '당첨금',
    colPreBalance: '베팅 전',
    colAfterBalance: '베팅 후',
    categorySlot: '슬롯',
    categoryLive: '라이브',
    categoryFishing: '피싱',
    categoryMini: '미니',
    categorySports: '스포츠',
    categoryAll: '전체',
    categoryOther: '기타',
    errorNoLogin: '로그인 정보가 없습니다. 다시 로그인해 주세요.',
    errorNoDateRange: '조회 기간을 선택해 주세요.',
    errorDateRange: '시작일은 종료일보다 늦을 수 없습니다.'
  },
  attendance: {
    title: '출석부',
    desc: '매일 출석하고 연속 출석 보상을 받아 보세요.',
    prevMonth: '이전 달',
    nextMonth: '다음 달',
    weekdays: ['일', '월', '화', '수', '목', '금', '토'],
    today: '오늘',
    streakLabel: '출석연속일수',
    notChecked: '미출석',
    streakDays: '{days}일',
    checkIn: '출석하기',
    checkInDone: '출석 완료',
    checkInSuccess: '출석이 완료되었습니다.',
    alreadyChecked: '오늘은 이미 출석하셨습니다.',
    notEligible: '오늘 입금 금액이 {amount} 이상이어야 출석할 수 있습니다.',
    checkInFail: '출석 처리에 실패했습니다.',
    loading: '불러오는 중...',
    loadError: '출석 정보를 불러오지 못했습니다.',
    checkedAria: '{date} 출석 완료',
    todayAria: '오늘 {date}',
    checkedShort: '출석',
    rewardTitle: '▶ 출석일수 및 포인트 안내',
    reward1: '5일 연속 출석 3만 포인트 지급',
    reward2: '10일 연속 출석 5만 포인트 지급',
    reward3: '20일 연속 출석 8만 포인트 지급',
    reward4: '30일 연속 출석 10만 포인트 지급',
    noticeTitle: '▶ 주의사항 안내',
    notice1: '1일 입금 금액 {amount} 이상 출석 인정됩니다.',
    notice2: '지급된 포인트는 롤링 {percent} 후 환전 가능합니다.',
    notice3: '연속된 일자로 출석에만 인정됩니다.',
    notice4: '매월 1일을 기준으로 연속 출석 일수가 초기화 됩니다.',
    notice5: '출석이벤트 참여를 위해 지속적으로 기본 롤링만 충족 후 이용 시 해당이벤트 참여 제재되십니다.'
  },
  mypage: {
    title: '나의 페이지',
    desc: '회원 정보와 보유 자산을 확인할 수 있습니다.',
    loading: '회원 정보를 불러오는 중...',
    loadError: '회원 정보를 불러오지 못했습니다.',
    profileTitle: '회원정보',
    walletTitle: '보유 자산',
    inquiryTitle: '1대1 문의',
    inquiryDesc: '고객센터 문의 내역',
    bettingTitle: '베팅내역',
    bettingDesc: '최근 게임 베팅 기록',
    loginId: '아이디',
    memberLevel: '회원등급',
    name: '이름',
    phone: '휴대폰번호',
    referralCode: '추천코드',
    referralCodeEmpty: '없음',
    bankHolder: '예금주',
    bankName: '은행명',
    bankAccount: '계좌번호',
    joinDate: '가입일',
    lastLogin: '최근 로그인',
    balance: '보유머니',
    bonus: '보너스 금액',
    apiBalance: '게임 연동 잔액',
    point: '보유포인트',
    accountStatus: '계정 상태',
    lastDepositDate: '마지막 입금일',
    lastBetDate: '마지막 베팅일',
    deposit: '입금',
    withdraw: '출금',
    pointConvert: '포인트전환',
    goTo: '바로가기',
    pointConvertTitle: '포인트 전환',
    pointConvertLoading: '잔액 정보를 불러오는 중...',
    pointConvertAmount: '전환 포인트',
    pointConvertAmountPlaceholder: '전환할 포인트 입력',
    pointConvertAll: '전액',
    pointConvertSubmit: '포인트 → 보유머니 전환',
    pointConvertSubmitting: '전환 중...',
    pointConvertNote1: '보유 포인트를 보유머니로 전환합니다.',
    pointConvertNote2: '전환 신청 후 즉시 반영됩니다.',
    pointConvertLoadError: '잔액 정보를 불러오지 못했습니다.',
    pointConvertAmountRequired: '전환할 포인트를 입력해 주세요.',
    pointConvertAmountExceed: '보유 포인트보다 많은 금액은 전환할 수 없습니다.',
    pointConvertFail: '포인트 전환에 실패했습니다.',
    pointConvertSuccess: '포인트 전환이 완료되었습니다.'
  },
  member: {
    role1: '관리자',
    role2: '마스터',
    role3: '에이전트',
    role4: '루트 에이전트',
    role5: '플레이어',
    role6: 'BBS',
    role7: 'CP',
    role8: 'MJ',
    role9: '일반회원',
    levelTemplate: '{level}레벨',
    statusNormal: '정상',
    statusSuspended: '정지'
  },
  wallet: {
    depositTitle: '입금',
    withdrawTitle: '출금',
    depositTabBank: '계좌 입금',
    depositTabTether: '테더 입금',
    withdrawTabBank: '계좌 출금',
    withdrawTabTether: '테더 출금',
    depositTabAria: '입금 방식',
    withdrawTabAria: '출금 방식',
    subtitleBoth: '계좌이체 또는 테더(USDT)로 입출금을 신청할 수 있습니다.',
    subtitleTether: '테더(USDT)로 입출금을 신청할 수 있습니다.',
    subtitleBank: '계좌이체로 입출금을 신청할 수 있습니다.',
    tetherDepositGuideTitle: '테더 입금 안내',
    bankDepositGuideTitle: '계좌 입금 안내',
    bankWithdrawGuideTitle: '계좌 출금 안내',
    tetherWithdrawGuideTitle: '테더 출금 안내',
    tetherDepositGuideParagraph1: 'USDT(테더)로 입금하시려면 아래에서 금액과 내 지갑 주소를 입력한 뒤 입금 요청을 해 주세요.',
    tetherDepositGuideParagraph2: '요청 후 안내되는 테더 주소(TRC20)로 송금해 주시면, USDT 시세 기준으로 달러(USD) 금액이 반영됩니다.',
    tetherDepositGuideParagraph3Prefix: '주소·QR 문의는 ',
    tetherDepositGuideParagraph3Suffix: ' 또는 고객센터로 연락해 주세요.',
    bankDepositGuideParagraph1: '계좌이체로 입금하시려면 입금 금액과 계좌정보(은행명·입금자명·계좌번호)를 입력한 뒤 입금 요청을 해 주세요.',
    bankDepositGuideParagraph2: '요청 후 안내되는 전용 입금 계좌로 송금해 주시면 확인·처리됩니다.',
    bankDepositGuideParagraph3: '타인 명의·다른 금액 입금 시 확인이 지연될 수 있으며, 반드시 신청하신 금액과 동일하게 입금해 주세요.',
    bankWithdrawGuideParagraph1: '계좌 출금은 출금 금액과 은행명·예금주·계좌번호를 입력한 뒤 출금 요청을 해 주세요.',
    bankWithdrawGuideParagraph2Prefix: '등록하신 계좌 정보가 정확한지 확인해 주시고, 문의는 고객센터 또는 ',
    bankWithdrawGuideParagraph2Suffix: '로 연락해 주세요.',
    tetherWithdrawGuideParagraph1: 'USDT(테더) 출금은 출금 금액과 테더 주소(TRC20)를 입력한 뒤 출금 요청을 해 주세요.',
    tetherWithdrawGuideParagraph2Prefix: '출금 절차나 테더 주소 관련 문의는 고객센터 또는 ',
    tetherWithdrawGuideParagraph2Suffix: '로 연락해 주세요.',
    tetherDepositRequestTitle: '테더 입금 요청',
    bankDepositRequestTitle: '계좌 입금 요청',
    bankWithdrawRequestTitle: '계좌 출금 요청',
    tetherWithdrawRequestTitle: '테더 출금 요청',
    depositAmountLabel: '입금 금액',
    withdrawAmountLabel: '출금 금액',
    amountPlaceholder: '예: {amount}',
    quick10k: '1만',
    quick30k: '3만',
    quick50k: '5만',
    quick100k: '10만',
    quick500k: '50만',
    quick1m: '100만',
    quick10m: '천만',
    reset: '초기화',
    required: '필수',
    checking: '확인 중...',
    requesting: '요청 중...',
    walletAddressLabel: '내 지갑 주소',
    walletAddressPlaceholder: '내 지갑 주소를 입력해 주세요',
    walletCheck: '지갑확인',
    walletBalanceLabel: '보유코인',
    walletBalanceUnit: 'USDT',
    walletCheckHintDeposit: '입금 요청 전 지갑확인을 눌러 TRC20 USDT 보유량을 확인해 주세요.',
    walletCheckHintWithdraw: '출금 요청 전 지갑확인을 눌러 TRC20 USDT 보유량을 확인해 주세요.',
    tetherAddressLabel: '테더 주소',
    tetherAddressPlaceholder: 'USDT(테더) TRC20 출금 주소를 입력해 주세요',
    bankInfoGroup: '계좌정보',
    bankNameLabel: '은행명',
    bankNamePlaceholder: '예: 국민은행',
    depositorNameLabel: '입금자명',
    depositorNamePlaceholder: '입금자명',
    accountHolderLabel: '예금주',
    accountHolderPlaceholder: '예금주 실명',
    accountNumberLabel: '계좌번호',
    accountNumberPlaceholder: '하이픈(-) 없이 숫자만 입력해 주세요',
    availableBalanceLabel: '출금 가능 금액',
    checkAvailableBalance: '출금 가능 금액 확인',
    depositRequest: '입금 요청',
    withdrawRequest: '출금 요청',
    supportInquiry: '고객센터 문의',
    tetherAddressGuide: '테더주소 안내',
    networkTrc20: 'TRC20',
    networkHint: 'TRC20(트론) 네트워크로만 입금해 주세요.',
    requestedAmount: '요청 금액: {amount} USDT',
    qrAlt: '테더 입금 QR 코드',
    qrLoading: 'QR 생성 중...',
    qrCaption: 'TRC20 QR 스캔 입금',
    copyAddress: '주소 복사',
    copiedAddress: '복사됨',
    addressCopied: '주소가 복사되었습니다',
    tetherAddressCopied: '테더 주소가 복사되었습니다.',
    addressCopyFail: '주소 복사에 실패했습니다.',
    copyBankName: '은행명 복사',
    copyAccountNo: '계좌번호 복사',
    copyHolder: '예금주 복사',
    bankAccountGuide: '입금 계좌 안내',
    bankDepositHint: '아래 계좌로 {amount}을 입금해 주세요.',
    bankName: '은행명',
    accountNumber: '계좌번호',
    accountHolder: '예금주',
    depositHistoryTitle: '입금 내역',
    withdrawHistoryTitle: '출금 내역',
    historyDesc: '신청 중·완료 등 모든 내역이 표시됩니다.',
    historyReloadDeposit: '입금 내역 새로고침',
    historyReloadWithdraw: '출금 내역 새로고침',
    loadingDepositHistory: '입금 내역을 불러오는 중...',
    loadingWithdrawHistory: '출금 내역을 불러오는 중...',
    loadDepositHistoryError: '입금 내역을 불러오지 못했습니다.',
    loadWithdrawHistoryError: '출금 내역을 불러오지 못했습니다.',
    emptyDepositHistory: '입금 내역이 없습니다.',
    emptyWithdrawHistory: '출금 내역이 없습니다.',
    colRequestDate: '신청일시',
    colType: '구분',
    colAmount: '금액',
    colDepositInfo: '입금 정보',
    colWithdrawInfo: '출금 정보',
    colMemo: '메모',
    colStatus: '상태',
    colProcessedDate: '처리일시',
    statusRequest: '신청',
    statusWaiting: '대기',
    statusComplete: '완료',
    statusCancel: '취소',
    statusDelete: '삭제',
    statusUnknown: '알 수 없음',
    chargeTypeNormal: '일반 충전요청',
    chargeTypeForce: '강제충전',
    chargeTypeOther: '기타',
    withdrawTypeNormal: '일반출금',
    withdrawTypeForce: '강제출금',
    withdrawTypeOther: '기타',
    depositMinAmount: '입금 금액은 {amount} 이상 입력해 주세요.',
    depositWalletRequired: '내 지갑 주소를 입력해 주세요.',
    depositWalletCheckRequired: '지갑확인을 완료한 후 입금 요청을 해 주세요.',
    depositRateLoading: 'USDT 환율 정보를 불러오는 중입니다. 잠시 후 다시 시도해 주세요.',
    depositSuccess: '입금 요청이 접수되었습니다.',
    depositFail: '입금 요청에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    depositPending: '이미 입금 요청이 진행 중입니다. 처리가 완료된 후 다시 요청해 주세요.',
    pgDepositGuideTitle: 'PG 입금 안내',
    pgDepositGuideBody: '결제 수단(CashApp/Chime/Google Pay/Apple Pay)과 금액을 선택한 뒤 입금 신청을 누르면 결제 화면으로 이동합니다. 결제가 완료되면 자동으로 잔액에 반영됩니다.',
    pgDepositRequestTitle: 'PG 입금 신청',
    pgWayCodeLabel: '결제 수단',
    pgWayCashApp: 'CashApp',
    pgWayChime: 'Chime',
    pgWayGooglePay: 'Google Pay',
    pgWayApplePay: 'Apple Pay',
    pgWayCodeRequired: '결제 수단을 선택해 주세요.',
    pgAmountSelectLabel: '입금 금액 선택',
    pgAmountUnselected: '금액을 선택해 주세요',
    pgAmountRequired: '입금 금액을 아래에서 선택해 주세요.',
    pgDepositOpenCashier: '결제 화면 열기',
    pgDepositRedirecting: '결제 화면으로 이동합니다…',
    pgWithdrawGuideTitle: 'PG 출금 안내',
    pgWithdrawGuideBody: '결제 수단(CashApp/Chime)과 수취 정보를 입력해 출금을 신청하세요. 신청 즉시 PG로 송금 요청이 전송되며, 처리 완료 시 자동 반영됩니다.',
    pgWithdrawRequestTitle: 'PG 출금 신청',
    pgCashtag: 'Cashtag',
    pgCashtagPlaceholder: '$username',
    pgEmail: '이메일',
    pgEmailPlaceholder: 'name@example.com',
    pgCardNumber: '카드번호',
    pgCardNumberPlaceholder: '카드번호',
    pgCardValid: '유효기간',
    pgCardValidPlaceholder: 'MM/YYYY',
    pgAccountNumber: '계좌번호',
    pgAccountNumberPlaceholder: 'Account number',
    pgRoutingNumber: 'Routing Number',
    pgRoutingNumberPlaceholder: '9자리 routing number',
    pgChimeSign: 'Chime 계정',
    pgChimeSignPlaceholder: '$chimeSign',
    pgZelleSign: 'Zelle (이메일/전화)',
    pgZelleSignPlaceholder: 'email or +1phone',
    pgReceiveInfo: '수취 정보',
    pgReceiveInfoPlaceholder: '수취 정보를 입력하세요',
    pgReceiveRequired: '수취 정보를 입력해 주세요.',
    bankNameRequired: '은행명을 입력해 주세요.',
    depositorRequired: '입금자명을 입력해 주세요.',
    accountRequired: '계좌번호를 입력해 주세요.',
    invalidTronAddress: '올바른 TRC20 지갑 주소를 입력해 주세요.',
    walletBalanceFail: '지갑 잔액 조회에 실패했습니다.',
    walletBalanceNetworkFail: '지갑 잔액 조회에 실패했습니다. 네트워크 연결을 확인해 주세요.',
    depositNoteMismatch: '신청 금액과 다른 금액 입금 시 확인이 지연될 수 있습니다.',
    withdrawMinAmount: '출금 금액은 {amount} 이상 입력해 주세요.',
    withdrawBalanceLoading: '출금 가능 금액 정보를 불러오는 중입니다. 잠시 후 다시 시도해 주세요.',
    withdrawExceedAvailable: '요청하신 출금 금액이 출금 가능 머니({amount})를 초과했습니다.',
    withdrawExceedBalance: '요청하신 출금 금액이 출금 가능 머니를 초과했습니다. 출금 규정(베팅 요건·보너스 차감)을 확인해 주세요.',
    withdrawPending: '이미 출금 요청이 진행 중입니다. 처리가 완료된 후 다시 요청해 주세요.',
    withdrawLimitMinutes: '출금 신청은 {minutes}분 간격으로 가능합니다. 잠시 후 다시 시도해 주세요.',
    withdrawLimitGeneric: '출금 신청 제한 시간이 지나지 않았습니다. 잠시 후 다시 시도해 주세요.',
    withdrawSuccess: '출금 요청이 접수되었습니다.',
    withdrawFail: '출금 요청에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    pgWithdrawCreateFail: 'PG 출금 요청에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    tetherAddressRequired: '테더 주소를 입력해 주세요.',
    withdrawWalletCheckRequired: '지갑확인을 완료한 후 출금 요청을 해 주세요.',
    holderRequired: '예금주를 입력해 주세요.',
    availableModalTitle: '출금 가능 금액 안내',
    availableModalLabel: '현재 출금 가능 금액',
    refreshBalance: '금액 새로고침',
    amountInfoTitle: '금액 정보',
    amountInfoAria: '출금가능 금액 계산 안내',
    totalDeposit: '총입금액',
    totalBet: '총베팅액',
    requiredBet: '필요 베팅액 (총입금 × {percent})',
    heldMoney: '보유머니',
    heldBonus: '보유보너스 금액',
    withdrawRule: '출금 규정',
    formula: '계산식',
    rulesTitle: '출금 규정 안내',
    ruleMetSummary: '베팅 요건 충족 — 보유머니 전액 출금 가능',
    ruleNotMetSummary: '베팅 요건 미충족 — 보너스 금액 차감 후 출금',
    formulaCalculating: '출금 가능 금액 계산 중',
    ruleInfoLoading: '출금 규정 정보를 불러오는 중입니다.',
    conditionChecking: '출금 조건을 확인하는 중입니다.',
    conditionLoadFail: '출금 조건 정보를 불러오지 못했습니다.',
    conditionMet: '현재 총베팅액({totalBet})이 필요 베팅액({requiredBet})보다 많아, 보유머니 전액 출금이 가능합니다.',
    conditionNotMet: '현재 총베팅액({totalBet})이 필요 베팅액({requiredBet}) 이하이므로, 출금 가능 머니는 보유머니에서 보너스를 뺀 금액으로 제한됩니다.',
    ruleBetMetTitle: '베팅 요건 충족',
    ruleBetMetDesc: '총베팅액이 총입금액 × {percent}보다 크면 보유머니 전액까지 출금 신청할 수 있습니다.',
    ruleBetNotMetTitle: '베팅 요건 미충족',
    ruleBetNotMetDesc: '총베팅액이 위 기준 이하이면 출금 가능 머니는 보유머니 − 보너스 금액으로 제한됩니다.',
    ruleTotalDepositNote: '출금 신청·처리 시 신청하신 출금 금액만큼 차감됩니다.',
    ruleTotalBetNote: '입금 이후 첫 출금 전까지 누적된 베팅 금액이며, 출금 처리 시 0으로 초기화됩니다.',
    amountWon: '{amount}',
    rateLabel: '1 USDT = {rate}',
    rateLabelBithumb: '빗썸 1 USDT = {rate}',
    rateLabelUsd: '1 USDT ≈ {rate} (연동)',
    rateLive: '실시간',
    rateConnectFail: '빗썸 환율 연결에 실패했습니다.',
    rateDisconnected: '빗썸 환율 연결이 끊어졌습니다.',
    networkFeeTitle: 'TRC20 네트워크 수수료',
    networkFeeSubtitle: 'TronGrid 공식 API 시뮬레이션 · 실제와 차이 날 수 있음',
    networkFeeRefresh: '10초마다 갱신',
    networkFeeEst: '예상 수수료',
    networkFeeTrxHint: '(약 {trx} TRX)',
    networkFeeBaseDeposit: '입금 반영 USDT',
    networkFeeBaseWithdraw: '출금 신청 USDT',
    networkFeeTotalDeposit: '실제 송금 USDT',
    networkFeeTotalWithdraw: '실제 수령 USDT',
    networkFeeNote: '받는 주소·지갑 TRX/Energy 상태에 따라 실제 수수료는 달라질 수 있습니다.',
    networkFeeLoading: '네트워크 수수료 정보를 불러오는 중입니다. 잠시 후 다시 시도해 주세요.',
    networkFeeSimpleRequest: '요청',
    networkFeeSimpleFee: '수수료',
    networkFeeSimpleLoading: '수수료 확인 중…',
    chargeMemo: '{krw} = {usdt}USDT',
    withdrawMemo: '{krw} = {usdt}USDT / 수수료 {feeUsdt}USDT'
  },
  lang: {
    title: '언어 설정',
    changed: '언어가 변경되었습니다.'
  },
  payment: {
    depositSubtitleBoth: '계좌이체 또는 테더(USDT)로 입금을 신청할 수 있습니다.',
    depositSubtitleTether: '테더(USDT)로 입금을 신청할 수 있습니다.',
    depositSubtitleBank: '계좌이체로 입금을 신청할 수 있습니다.',
    depositSubtitlePg: '결제 게이트웨이(PG)로 입금할 수 있습니다. 신청 후 결제 화면으로 이동합니다.',
    withdrawSubtitleBoth: '계좌이체 또는 테더(USDT)로 출금을 신청할 수 있습니다.',
    withdrawSubtitleTether: '테더(USDT)로 출금을 신청할 수 있습니다.',
    withdrawSubtitleBank: '계좌이체로 출금을 신청할 수 있습니다.',
    withdrawSubtitlePg: 'PG로 출금을 신청합니다. 신청 즉시 자동 송금 요청이 전송됩니다.'
  }
}
